<template>
  <v-container class="custom-container container" >
    <div class="list_form_card" >

      <div class="list-container" >
        <h2>จัดการข้อมูล Lead</h2>
        <v-btn color="primary">
          <v-icon left>mdi-file-excel</v-icon>
          Import ช้อมูล
        </v-btn>
      </div>

      <div class="form_table" >

        <v-text-field
            v-model="search"
            label="ค้นหา"
            required
        ></v-text-field>

        <v-data-table
            :headers="headers"
            :items="resultData"
            :fields="fields"
            class="elevation-1"
            :search="search"
            :options.sync="options"
            sort-by="id"
            :sort-desc=true
            :server-items-length="totalItems"
            :loading="loading"
        >
          <template v-slot:top>
          </template>
          <template v-slot:item.fullname="{ item }">
            {{ item.first_name }} {{ item.last_name }}
          </template>
          <template v-slot:item.created_at="{ item }">
            {{  moment(item.created_at).format("DD/MM/yyyy") }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon
                small
                class="mr-2"
                @click="editItem(item)"
            >
              mdi-pencil
            </v-icon>

            <v-icon
                small
                class="mr-2"
                @click="deleteItem(item.id)"
            >
              mdi-trash-can
            </v-icon>

          </template>
          <template v-slot:no-data>
            <v-btn
                color="primary"
                @click="GetData()"
            >
              Reset
            </v-btn>
          </template>

        </v-data-table>
      </div>

    </div>

  </v-container>
</template>
<script>
// @ is an alias to /src
//import {} from "../lib/controller";
// import {ResponseData} from "../lib/utility";
import  {baseUrl } from "../const/api";


import {DeleteUser, GetLead, UpdateUser} from "../lib/controller";
import {ResponseData} from "../lib/utility";

export default {
  name: 'Lead',
  components: {},
  data: () => ({
    items: [
      {
        text: 'Home',
        disabled: false,
        href: '/',
      },
    ],
    headers: [
      { text: 'Production Date', value: 'date', key: 'date',width:150 },
      { text: 'Shift', value: 'shift', key: 'shift' },
      { text: 'M/C', value: 'machine', key: 'machine' },
      { text: 'Orde', value: 'order', key: 'order' },
      { text: 'Model ที่ขึ้นจริง', value: 'actual_model', key: 'actual_model',width:150 },
      { text: 'Leader Code', value: 'leader_code', key: 'leader_code',width:150 },
      { text: 'Setup Code 8:00-17:00', value: 'setup_code_1', key: 'setup_code_1',width:200 },
      { text: 'Setup Name 8:00-17:00', value: 'setup_name_1', key: 'setup_name_1',width:200 },
      { text: 'ตัดรอบ SETUP', value: 'setup_cutoff_1', key: 'setup_cutoff_1',width:150 },
      { text: 'Operator Code 8:00-17:00', value: 'operator_code_1', key: 'operator_code_1',width:250 },
      { text: 'Operator Name 8:00-17:00', value: 'operator_name_1', key: 'operator_name_1',width:250 },
      { text: 'ตัดรอบ Operator', value: 'operator_cutoff_1', key: 'operator_cutoff_1',width:150 },
      { text: 'Hours 8:00-17:00', value: 'hours_1', key: 'hours_1',width:250 },
      { text: 'Setup Code 17:00-20:00', value: 'setup_code_2', key: 'setup_code_2',width:250 },
      { text: 'Setup Name 17:00-20:00', value: 'setup_name_2', key: 'setup_name_2',width:250 },
      { text: 'ตัดรอบ SETUP', value: 'setup_cutoff_2', key: 'setup_cutoff_2',width:150 },
      { text: 'Setup Continued 17:00-20:00', value: 'setup_continued_2', key: 'setup_continued_2',width:250 },
      { text: 'Setup Substitute 17:00-20:00', value: 'setup_substitute_2', key: 'setup_substitute_2',width:250 },
      { text: 'Operator Code 17:00-20:00', value: 'operator_code_2', key: 'operator_code_2',width:250 },
      { text: 'Operator Name 17:00-20:00', value: 'operator_name_2', key: 'operator_name_2',width:250 },
      { text: 'ตัดรอบ Operator', value: 'operator_cutoff_2', key: 'operator_cutoff_2',width:150 },
      { text: 'ต่อเนื่อง', value: 'operator_continued_2', key: 'operator_continued_2',width:150 },
      { text: 'แทน', value: 'operator_substitute_2', key: 'operator_substitute_2',width:100 },
      { text: 'ชั่วโมงที่ได้ 17:00 - 20:00', value: 'hours_2', key: 'hours_2',width:190 },
      { text: 'Target', value: 'target', key: 'target',width:100 },
      { text: 'Output', value: 'output', key: 'output',width:100 },
    ],
    resultData: [],
    is_loading:false,
    valid: true,
    user: JSON.parse(localStorage.getItem('user')),
    name: "",
    id: 0,
    pin: "",
    show1: false,
    loading: false,
    show4: false,
    type: 'serial',
    image_preview: "",
    edit: "",
    search: "",
    serial: "",
    nickname: "",
    username: "",
    hospital: [],
    department: [],

    first_name: "",
    hospital_id: "",
    department_id: "",
    last_name: "",
    tel: "",
    address: "",
    email: "",
    is_admin: 0,
    is_edit: false,
    baseUrl: baseUrl,
    password: '',
    password_confirm: '',
    email_rules: [
      v => !!v || 'กรุณากรอกอีเมล',
      v => /.+@.+\..+/.test(v) || 'รูปแบบอีเมลไม่ถูกต้อง',
    ],
    PinRule: [
      (v) => !!v || "กรุณากรอก PIN",
      (v) =>
          (v && v.length <= 4) ||
          "PIN ต้องไม่เกิน 4 ตัว",
    ],
    permissions: [
      { label: 'จัดการไฟล์ NCP', value: '1' },
      { label: 'จัดการไฟล์ NG', value: '2' },
      { label: 'จัดการไฟล์ LEAD', value: '3' },
      { label: 'โปรเซสการทำงาน', value: '4' },
      // Add more as needed
    ],
    selectedPermissions: [],
    options: {},
    totalItems: 0,
    fields: "",
  }),
  watch: {
    options: {
      handler () {
        this.GetData()
      },
      deep: true,
    },
  },
  methods:{
    validate() {
      console.log(this.file)
      if (this.$refs.form.validate()) {
        this.Update();
      }
    },
    reset () {
      this.$refs.form.reset()
      this.id = 0;
    },
    goBack(){
      this.$router.push({ path: '/manage/'})
    },
    cancle () {
      this.$refs.form.reset()
      this.id = 0;
      this.is_edit = false;
    },
    async Update(){

      let formData = new FormData();

      formData.append("first_name",this.first_name);
      formData.append("last_name",this.last_name);
      formData.append("username",this.username);
      formData.append("password",this.password);
      formData.append("tel",this.tel);
      formData.append("permissions",this.selectedPermissions.join(','));


      if(this.password){
        formData.append("password",this.password);
      }



      if(this.id != 0){
        formData.append('is_edit',this.id)
      }


      await UpdateUser(formData, (response) => {
        console.warn(response);
        const {status, data} = ResponseData(response)
        switch (status) {
          case 201:
            console.log(data)

            this.$swal({
              title: "สำเร็จ",
              text: "อัพเดทสำเร็จ",
              icon: "success",
              confirmButtonText: "ตกลง"
            }).then(async () => {
              await this.GetData();
            });


            break;

          case 422 :

            for (const [key, value] of Object.entries(data)) {
              console.log(`${key}: ${value}`);

              this.$toast.open({
                message: `${value}`,
                type: "warning",
                duration: 10000,
                dismissible: true
              })

            }

            break;

          case 410 :

            for (const [key, value] of Object.entries(data)) {
              console.log(`${key}: ${value}`);

              this.$toast.open({
                message: `${value}`,
                type: "warning",
                duration: 10000,
                dismissible: true
              })

            }

            break;

          default:


            break;
        }

      })



    },

    editItem(item){


      this.is_edit = true;
      console.log(item)
      this.password = null;
      this.password_confirm = null;
      this.first_name = item.first_name;
      this.last_name = item.last_name;
      this.username = item.username;
      this.tel = item.tel;
      this.pin = item.pin;
      this.is_admin = item.is_admin == '1' ? true : false ;
      this.id = item.id;


    },
    async GetData(){

      this.loading = true;
      console.warn(sortBy, sortDesc)
      const { sortBy, sortDesc, page, itemsPerPage } = this.options

      const params = {
        page,itemsPerPage,sortDesc:sortDesc[0],sortBy:sortBy[0]
      }

      if(this.search){
        params.keyword = this.search
      }

      console.log(this)
      await GetLead(params,(response)=>{
        const {status, data} = ResponseData(response)
        this.loading = false;
        switch (status){
          case 200:
            this.resultData = data.data;
            this.totalItems = data.total;
            this.itemsPerPage = data.to;
            break;
          default:
            break;
        }

      });
    },
    async deleteItem(id){
      console.log(id)
      this.$swal({
        title: 'ต้องการลบใช่หรือไม่ ?',
        showCancelButton: true,
        confirmButtonText: 'ตกลง',
        cancelButtonText:"ยกเลิก",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.delete(id)
        }
      })

      ;
    },
    async delete(id){
      let Swal = this.$swal;

      await DeleteUser(id,async  (response)=>{
        const {status, data} = ResponseData(response)
        console.log(data);
        switch (status){
          case 200:
            Swal({
              icon: 'success',
              title: 'Success',
            })

            await this.GetData()

            break;
          default:
            break;
        }

      });

    },
    CheckLogin(){
      console.log(this.$router.currentRoute.path)
      const user = JSON.parse(localStorage.getItem('user'));
      this.user = user;
    },
  },
  async mounted() {
    await this.GetData();
  }
}
</script>
<style>

.list_item img{
  width: 60%;
}
.list_item font{
  font-size: 1.5rem;
  color: black;
}
.container{
  height: 100%;
}
.img-logo{
  width: 30rem;
}
.v-main__wrap{
  height: 100%;
}
.v-main{
  height: 100%;
}
.ip_custom{
  opacity: 0;
}
</style>
